var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChromeExtensionDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M248.179,249.94h-14v11.2a.955.955,0,0,0,.955.955h12.09a.955.955,0,0,0,.955-.955v-11.2Z",
    transform: "translate(-234.18 -249.94)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.446,
    y1: -1.36,
    x2: -1.259,
    y2: -1.36,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -8.019,
    y1: 1.957,
    x2: -7.792,
    y2: 1.957,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e8e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34a853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -3.485,
    y1: 5.689,
    x2: -3.16,
    y2: 5.689,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbbc04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcc934"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chrome_store_-_color",
    "data-name": "Chrome store - color",
    transform: "translate(-955 -620)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "art-layer",
    transform: "translate(955 620.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M248.179,249.94h-14v11.2a.955.955,0,0,0,.955.955h12.09a.955.955,0,0,0,.955-.955v-11.2Z",
    transform: "translate(-234.18 -249.94)",
    fill: "#f1f3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M248.179,249.94h-14v11.2a.955.955,0,0,0,.955.955h12.09a.955.955,0,0,0,.955-.955v-11.2Z",
    transform: "translate(-234.18 -249.94)",
    fill: "#f1f3f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_971",
    "data-name": "Rectangle 971",
    width: 13.999,
    height: 6.111,
    transform: "translate(0 0)",
    fill: "#e8eaed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M340.193,279.843h-3.177a.636.636,0,0,1-.636-.636h0a.636.636,0,0,1,.636-.637h3.177a.636.636,0,0,1,.636.636h0A.637.637,0,0,1,340.193,279.843Z",
    transform: "translate(-331.605 -277.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3132",
    "data-name": "Group 3132",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M271.95,363.412l.833,2.543,1.785,1.992,2.616-4.532h5.235a6.045,6.045,0,0,0-10.47,0Z",
    transform: "translate(-270.185 -355.233)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M260.719,434.07l1.785-1.993.832-2.542H258.1L255.486,425a6.048,6.048,0,0,0,5.233,9.07Z",
    transform: "translate(-253.72 -416.821)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M389.235,425H384l2.616,4.532L384,434.067A6.047,6.047,0,0,0,389.235,425Z",
    transform: "translate(-377.001 -416.821)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 3.022,
    cy: 3.023,
    rx: 3.022,
    ry: 3.023,
    transform: "translate(3.978 8.18)",
    fill: "#f1f3f4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 2.456,
    cy: 2.456,
    rx: 2.456,
    ry: 2.456,
    transform: "translate(4.544 8.746)",
    fill: "#1a73e8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_972",
    "data-name": "Rectangle 972",
    width: 13.999,
    height: 0.079,
    transform: "translate(0 6.111)",
    fill: "#bdc1c6",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_973",
    "data-name": "Rectangle 973",
    width: 13.999,
    height: 0.079,
    transform: "translate(0 6.031)",
    fill: "#bdc1c6",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_974",
    "data-name": "Rectangle 974",
    width: 14,
    height: 14,
    transform: "translate(955 620)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeExtensionDarkIcon);
export default __webpack_public_path__ + "static/media/chrome-extension-dark-icon.e3d9675c43144c5e032564b7d2cbeb3f.svg";
export { ForwardRef as ReactComponent };